export const WORK_CONDITIONS_CHANGE_REQUEST_PATH =
  "/requests/work-conditions-change/:requestId?" as const;
